import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import AIAssistant from "./components/AI Assistant";

import ScrollToTop from "../src/ScrollToTop.js";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Landing from "./components/Landing/Landing";
import Login from "./components/Login/Login.jsx";
import UserRegistrations from "./components/Admin/UserRegistrations/UserRegistrations.js";
import UserView from "./components/Admin/UserRegistrations/UserView.js";
import UserProfile from "./components/Candidate/Profile/UserProfile.js";
import AdminSidebar from "./components/Admin/Layout/Sidebar.jsx";
import AdminHeader from "./components/Admin/Layout/Header.jsx";
import SuperAdminSidebar from "./components/SuperAdmin/Layout/Sidebar.jsx";
import SuperAdminHeader from "./components/SuperAdmin/Layout/Header.jsx";
import CandidateSidebar from "./components/Candidate/Layout/Sidebar.jsx";
import CandidateHeader from "./components/Candidate/Layout/Header.jsx";
import Platform from "./components/Landing/Platform.jsx";
import Competency from "./components/Landing/Competency.jsx";
import Industries from "./components/Landing/Industries.jsx";
import Services from "./components/Landing/Services.jsx";
import About from "./components/Landing/About.jsx";
import JoinEcosystem from "./components/Landing/JoinEcosystem.jsx";
import MentorPage from "./components/Landing/Mentor.js";
import MentorDetail from "./components/Landing/MentorDetail.js";
import RegisterStage1 from "./components/TenantLanding/RegisterForms/RegisterStage1.js";
import RegisterStage2 from "./components/TenantLanding/RegisterForms/RegisterStage2.js";
import TenantTable from "./components/SuperAdmin/Tenants/TenantTable.js";
import AddTenant from "./components/SuperAdmin/Tenants/AddTenant.js";
// ✅ ADDED: Tenant Pages were missing before
import TenantLanding from "./components/TenantLanding/Landing/TenantLanding.jsx";
import TenantLogin from "./components/TenantLanding/Login/TenantLogin.jsx";
import TenantPlatform from "./components/TenantLanding/Landing/Platform.jsx";
import Industry from "./components/SuperAdmin/Industries/Industry.js";
import ScopeCatelogs from "./components/SuperAdmin/ScopeCatelogs/ScopeCatelogs.js";
import FormModules from "./components/SuperAdmin/FormModules/FormModules.js";
import ScopeModules from "./components/SuperAdmin/ScopeModules/ScopeModules.js";
import FormFields from "./components/SuperAdmin/FormFields/FormFields.js";
import Roles from "./components/SuperAdmin/Roles/Roles.js";
import Users from "./components/SuperAdmin/Users/Users.js";
import AddIndustry from "./components/SuperAdmin/Industries/AddIndustry.js";
import AddScopeCatalog from "./components/SuperAdmin/ScopeCatelogs/AddScopeCatalog.js";
import AddFormModule from "./components/SuperAdmin/FormModules/AddFormModule.js";
import AddScopeModule from "./components/SuperAdmin/ScopeModules/AddScopeModule.js";
import AddFormField from "./components/SuperAdmin/FormFields/AddFormField.js";
import ViewTenantPage from "./components/SuperAdmin/Tenants/ViewTenantDetails.js";
import Invitation from "./components/SuperAdmin/Invitation/Invitation.js";
import UserInvitation from "./components/Admin/Invitation/Invitation.js";
import Profile from "./components/Admin/Profile/Profile.js";
import CalculationRule from "./components/Admin/CalculationRules/CalculationRule.js";
import AddCalculationRule from "./components/Admin/CalculationRules/AddCalculationRule.js";
import TenantContacts from "./components/Admin/TenantContacts/TenantContacts.js";
import AddTenantContact from "./components/Admin/TenantContacts/AddTenantContact.js";
import TenantSubscription from "./components/Admin/TenantSubscription/TenantSubscription.js";
import AddModule from "./components/Admin/Module/AddModule.js";
import AddTenantModuleEntitlement from "./components/Admin/TenantModuleEntitlement/AddTenantModuleEntitlement.js";
import AddTenantBranding from "./components/Admin/TenantBranding/AddTenantBranding.js";
import AddTenantReportTemplate from "./components/Admin/TenantReportTemplate/AddTenantReportTemplate.js";
import AddOrganization from "./components/Admin/Organizations/AddOrganization.js";
import AddSettings from "./components/Admin/Settings/AddSettings.js";
import AddLegalSettings from "./components/Admin/LegalSettings/AddLegalSettings.js";
import AddDomain from "./components/Admin/Domain/AddDomain.js";
import AddTenantNda from "./components/Admin/TenantNda/AddTenantNda.js";
import AddTenantSecuritySettings from "./components/Admin/TenantSecuritySettings/AddTenantSecuritySettings.js";
import AddTenantIPRestriction from "./components/Admin/TenantIPRestriction/AddTenantIPRestriction.js";
import TenantWorkflow from "./components/Admin/WorkFlows/TenantWorkFlow.js";
import TenantIntegration from "./components/Admin/Integration/TenantIntegration.js";
import TenantBilling from "./components/Admin/Billing/TenantBilling.js";
import DisclosureConsent from "./components/Admin/Disclosure/DisclosureConsent.js";
import AddTenantOperationLog from "./components/Admin/TenantOperationLog/AddTenantOperationLog.js";
import AddTenantTerminology from "./components/Admin/TenantTerminology/AddTenantTerminology.js";
import AddDocumentNumbering from "./components/Admin/DocumentNumbering/AddDocumentNumbering.js";
import AddTenantNotificationSettings from "./components/Admin/TenantNotificationSettings/AddTenantNotificationSettings.js";
import AddDataExportRequest from "./components/Admin/DataExportRequest/AddDataExportRequest.js";
import AddTenantInvitation from "./components/Admin/TenantInvitation/AddTenantInvitation.js";
import AddTenantApprovalMatrix from "./components/Admin/TenantApprovalMatrix/AddTenantApprovalMatrix.js";
import AddTenantDocument from "./components/Admin/TenantDocument/AddTenantDocument.js";
import AddConflictOfInterestDeclaration from "./components/Admin/ConflictOfInterestDeclaration/AddConflictOfInterestDeclaration.js";
import AddUser from "./components/Admin/Users/AddUser.js";
import AddTenantOperation from "./components/Admin/Organizations/AddTenantOperation.js";
import AddLocation from "./components/Admin/Organizations/AddLocation.js";
import AddLegalEntity from "./components/Admin/Organizations/AddLegalEntity.js";
import MyProfile from "./components/Admin/Organizations/MyProfile.js";
import ProjectForm from "./components/Admin/Projects/ProjectForm.js";
import ProjectRequirementForm from "./components/Admin/Projects/ProjectRequirementForm.js";
import ProjectMembershipForm from "./components/Admin/Projects/ProjectMembershipForm.js";
import ProjectCandidateForm from "./components/Admin/Projects/ProjectCandidateForm.js";
import ProjectDeploymentForm from "./components/Admin/Projects/ProjectDeploymentForm.js";
import ConflictOfInterestForm from "./components/Admin/Projects/ConflictOfInterestForm.js";
import AuthorizedRepresentatives from "./components/Admin/TenantContacts/AuthorizedRepresentatives.js";
import AddAuthorizedRepresentative from "./components/Admin/TenantContacts/AddAuthorizedRepresentative.js";
import AddClients from "./components/Admin/Organizations/AddClients.js";
import AddOtherOrganizations from "./components/Admin/Organizations/AddOtherOrganizations.js";
import ProjectCandidateView from "./components/Admin/Projects/ProjectCandidateView.js";
import AddDisclosureRequest from "./components/Admin/Projects/AddDisclosureRequest.js";
import AddTenantSubscription from "./components/Admin/TenantSubscription/AddTenantSubscription.js";
function AppContent() {
  const location = useLocation();
  const isLandingRoute = location.pathname === "/";

  const isAdminRoute =
    location.pathname.startsWith("/users-registrations") ||
    location.pathname.startsWith("/user-view") ||
    location.pathname.startsWith("/profile");

  const isSuperAdminRoute = location.pathname.startsWith("/superadmin");

  return (
    <>
      <ScrollToTop />

      {isLandingRoute && <Navbar />}

      <Routes>
        {/* Login Routes */}
        <Route path="/login" element={<Login />} />

        {/* ✅ ADDED: Tenant Routes */}
        <Route path="/Oceanstar" element={<TenantPlatform />} />
        <Route path="/Oceanstar/Login" element={<TenantLogin />} />
        <Route path="/Oceanstar/register-stage1" element={<RegisterStage1 />} />
        <Route
          path="/Oceanstar/register-stage1/:userId"
          element={<RegisterStage1 />}
        />
        <Route
          path="/Oceanstar/register-stage2/:userId"
          element={<RegisterStage2 />}
        />

        {/* <Route path="/:tenantSlug/*" element={<TenantRoutes />} /> */}

        {/* Tenant Admin Routes */}
        <Route
          path="/admin/users-registrations"
          element={<UserRegistrations />}
        />
        <Route path="/admin/profile" element={<Profile />} />
        <Route path="/user-view/:id" element={<UserView />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/admin/invitation" element={<UserInvitation />} />
        <Route path="/admin/calculation-rules" element={<CalculationRule />} />
        <Route
          path="/admin/calculation-rules/add"
          element={<AddCalculationRule />}
        />
        <Route path="/admin/contacts/add" element={<AddTenantContact />} />
        <Route path="/admin/contacts" element={<TenantContacts />} />
         <Route path="/admin/auth-rep/add" element={<AddAuthorizedRepresentative />} />
        <Route path="/admin/auth-rep" element={<AuthorizedRepresentatives />} />
        <Route path="/admin/operations" element={<AddTenantOperation />} />
        <Route path="/admin/locations" element={<AddLocation />} />
        <Route path="/admin/legalentities" element={<AddLegalEntity />} />
        <Route path="/admin/myprofile" element={<MyProfile />} />
        <Route path="/admin/add/subscription" element={<AddTenantSubscription />} />
        
        <Route
          path="/admin/subscriptions"
          element={<TenantSubscription />}
        />
        <Route
          path="/admin/subscription-usage"
          element={<TenantSubscription />}
        />
        <Route
          path="/admin/subscription-history"
          element={<TenantSubscription />}
        />
        <Route path="/admin/modules" element={<AddModule />} />
        <Route
          path="/admin/module-entitlement"
          element={<AddTenantModuleEntitlement />}
        />
        <Route path="/admin/branding" element={<AddTenantBranding />} />
        <Route
          path="/admin/report-template"
          element={<AddTenantReportTemplate />}
        />
        <Route path="/admin/organization/add" element={<AddOrganization />} />
        <Route path="/admin/settings/add" element={<AddSettings />} />
        <Route path="/admin/legalsettings/add" element={<AddLegalSettings />} />
        <Route path="/admin/domain/add" element={<AddDomain />} />
        <Route path="/admin/nda/add" element={<AddTenantNda />} />
        <Route path="/admin/projects" element={<ProjectForm />} />
         <Route path="/admin/project-membership" element={<ProjectMembershipForm />} />
         <Route path="/admin/project-access" element={<ProjectMembershipForm />} />
         <Route path="/admin/project-candidates" element={<ProjectCandidateForm />} />
         <Route path="/admin/project-candidates/:id" element={<ProjectCandidateView />} />
         <Route path="/admin/disclosure-requests" element={<AddDisclosureRequest />} />
         <Route path="/admin/project-requirement" element={<ProjectRequirementForm />} />
        <Route path="/admin/work-flow" element={<TenantWorkflow />} />
        <Route path="/admin/Integration" element={<TenantIntegration />} />
        <Route path="/admin/billing" element={<TenantBilling />} />
         <Route path="/admin/disclosure-consent" element={<DisclosureConsent />} />
         <Route path="/admin/deployment" element={<ProjectDeploymentForm />} />
         <Route path="/admin/complaince" element={<ConflictOfInterestForm />} />
          <Route path="/admin/operationlog" element={<AddTenantOperationLog />} />
        <Route path="/admin/terminology" element={<AddTenantTerminology />} />
        <Route path="/admin/numbering" element={<AddDocumentNumbering />} />
        <Route path="/admin/notification-setting" element={<AddTenantNotificationSettings />} />
        <Route path="/admin/data-export-request" element={<AddDataExportRequest />} />
        <Route path="/admin/tenantinvitation" element={<AddTenantInvitation />} />
        <Route path="/admin/approvalmatrix" element={<AddTenantApprovalMatrix />} />
        <Route path="/admin/document" element={<AddTenantDocument />} />
        <Route path="/admin/conflictofinterest" element={<AddConflictOfInterestDeclaration />} />
        <Route path="/admin/user" element={<AddUser />} />
        <Route path="/admin/clients" element={<AddClients />} />
        <Route path="/admin/other-organizations" element={<AddOtherOrganizations />} />
        <Route
          path="/admin/security-settings"
          element={<AddTenantSecuritySettings />}
        />
        <Route
          path="/admin/ip-restriction"
          element={<AddTenantIPRestriction />}
        />

        {/* SuperAdmin Routes */}

        <Route path="/superadmin/tenants/add-tenant" element={<AddTenant />} />
        <Route
          path="/superadmin/tenants/edit-tenant/:id"
          element={<AddTenant />}
        />
        <Route
          path="/superadmin/tenants/tenant-table"
          element={<TenantTable />}
        />
        <Route
          path="/superadmin/tenants/view-tenant/:id"
          element={<ViewTenantPage />}
        />
        <Route path="/catalog/industries" element={<Industry />} />
        <Route path="/catalog/add-industry" element={<AddIndustry />} />
        <Route path="/catalog/edit-industry/:id" element={<AddIndustry />} />
        <Route path="/catalog/scope-catalogs" element={<ScopeCatelogs />} />
        <Route
          path="/catalog/add-scope-catalog"
          element={<AddScopeCatalog />}
        />
        <Route
          path="/catalog/edit-scope-catalog/:id"
          element={<AddScopeCatalog />}
        />
        <Route path="/catalog/form-modules" element={<FormModules />} />
        <Route path="/catalog/add-form-module" element={<AddFormModule />} />
        <Route
          path="/catalog/edit-form-module/:id"
          element={<AddFormModule />}
        />
        <Route path="/catalog/scope-modules" element={<ScopeModules />} />
        <Route path="/catalog/add-scope-module" element={<AddScopeModule />} />
        <Route
          path="/catalog/edit-scope-module/:id"
          element={<AddScopeModule />}
        />
        <Route path="/catalog/form-fields" element={<FormFields />} />
        <Route path="/catalog/add-form-field" element={<AddFormField />} />
        <Route path="/catalog/edit-form-field/:id" element={<AddFormField />} />
        <Route path="/qualion/roles" element={<Roles />} />
        <Route path="/qualion/users" element={<Users />} />
        <Route path="/superadmin/invitation" element={<Invitation />} />

        {/* Landing Page Routes */}
        <Route path="/" element={<Platform />} />
        <Route path="/competency" element={<Competency />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/Landingpage_mentor" element={<MentorPage />} />
        <Route path="/mentor/:slug" element={<MentorDetail />} />
        <Route path="/join-ecosystem" element={<JoinEcosystem />} />
      </Routes>

      {isLandingRoute && <Footer />}

      <AIAssistant />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
